import PropTypes from "prop-types";
import React, { Component } from "react";

//Simple bar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import { API_WEB_URLS } from "constants/constAPI";

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.refDiv = React.createRef();
    this.state = {
      user: null
    };
  }

  componentDidMount() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    this.setState({
      user: obj
    });
    this.initMenu();
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props.type !== prevProps.type) {
      this.initMenu();
    }
  }

  initMenu() {
    new MetisMenu("#side-menu");

    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    for (let i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  // componentDidUpdate() {}

  scrollElement = item => {
    setTimeout(() => {
      if (this.refDiv.current !== null) {
        if (item) {
          const currentPosition = item.offsetTop;
          if (currentPosition > window.innerHeight) {
            if (this.refDiv.current)
              this.refDiv.current.getScrollElement().scrollTop =
                currentPosition - 300;
          }
        }
      }
    }, 300);
  };

  activateParentDropdown = item => {
    item.classList.add("active");
    const parent = item.parentElement;

    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      this.scrollElement(item);
      return false;
    }
    this.scrollElement(item);
    return false;
  };

  render() {

    const CustomerId  =  API_WEB_URLS.Customer;
    return (
      <React.Fragment>
        <SimpleBar autoHide={false} className="h-100" ref={this.refDiv}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              <li className="menu-title">{this.props.t("Menu")}</li>
              <li>
                <Link to="/#">
                  <i className="bx bx-home-circle" />
                  <span className="badge rounded-pill bg-info float-end">
                    04
                  </span>
                  <span>{this.props.t("Dashboards")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/dashboard">{this.props.t("Default")}</Link>
                  </li>
                </ul>
              </li>

              <li className="menu-title">{this.props.t("Apps")}</li>
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-store" />
                  <span>{this.props.t("Masters")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                <li>
                    <Link to="/UserMaster">{this.props.t("User Master")}</Link>
                  </li>
                <li>
                    <Link to="/GroupMaster">{this.props.t("Item Group")}</Link>
                  </li>
                  <li>
                    <Link to="/ItemType">{this.props.t("Item")}</Link>
                  </li>
                  <li>
                    <Link to="/CompanyMaster">{this.props.t("Item Company")}</Link>
                  </li>
                <li>
                    <Link to="/UnitMaster">{this.props.t("Item Unit")}</Link>
                  </li>
                <li>
                    <Link to="/GodownMaster">{this.props.t("Godown")}</Link>
                  </li>
                <li>
                    <Link to="/ItemMaster">{this.props.t("Color")}</Link>
                  </li>

{/*                  

                  <li>
                    <Link to="/Tax">{this.props.t("Tax")}</Link>
                  </li>

                  <li>
                    <Link to="/GSTGroupType">
                      {this.props.t("GSTGroupType")}
                    </Link>
                  </li> */}

                  <li>
                    <Link to="/City">{this.props.t("City")}</Link>
                  </li>

                  <li>
                    <Link to="/State">{this.props.t("State")}</Link>
                  </li>
                  <li>
                    <Link to="/Ledger">{this.props.t("Ledger")}</Link>
                  </li>

                  
                  

                  {/* <li>
                       <Link to="Country">{this.props.t("Country")}</Link>
                       </li> */}

                  
                  {/* <li>
                    <Link to="ConsigneeAddress">
                      {this.props.t("ConsigneeAddress")}
                    </Link>
                  </li>

                  <li>
                    <Link to="CalculationType">
                      {this.props.t("CalculationType")}
                    </Link>
                  </li> */}

                  {/* <li>
                       <Link to="HeightCalculation">{this.props.t("HeightCalculation")}</Link>
                       </li> */}

                  {/* <li>
                       <Link to="LengthCalculation">{this.props.t("LengthCalculation")}</Link>
                       </li> */}
                </ul>
              </li>

              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-receipt" />
                  <span>{this.props.t("Transaction")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                 
                  {/* <li>
                    <Link to="/addinvoice_new">{this.props.t("Invoice")}</Link>
                  </li> */}
                  <li>
                    <Link to="/estimateinvoice">{this.props.t("Estimate")}</Link>
                    <Link to="/EstimateOutside">{this.props.t("EstimateOutside")}</Link>
                  </li>
                  <li>
                    <Link to="/purchasegoods">{this.props.t("Purchase")}</Link>
                  </li>
                  <li>
                    <Link to="/salereturn">{this.props.t("Sale Return")}</Link>
                  </li>
                  <li style={{ display: "none" }}>
                    <Link to="/stockin">{this.props.t("Stock In")}</Link>
                  </li>
                 
                </ul>
              </li>

              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-receipt" />
                  <span>{this.props.t("Report")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  
                  <li>
                    <Link to="/stockData">{this.props.t("Stock Data")}</Link>
                  </li>
                  <li>
                    <Link to="/dayBook">{this.props.t("Day Book")}</Link>
                  </li>
                  <li>
                    <Link to="/groupwise">{this.props.t("Group Wise")}</Link>
                  </li>
                  {/* <li>
                    <Link to="/invoicedetailed">{this.props.t("Invoice Detailed")}</Link>
                  </li> */}
                  {/* <li>
                    <Link to="/saleitemwise">{this.props.t("Sale Item wise")}</Link>
                  </li> */}
                  {/* <li>
                      <Link to={{  pathname:"https://boldreports.shinewellinnovation.com/reporting/site/site1/reports/a1cd1911-430c-4572-bb00-5c4ee937f161/Merchant/CompanyWiseItemReport"}} target="_blank">{this.props.t("Company Wise")}</Link>
                    </li>
                  <li>
                    <Link to="/ExcelInvoice">{this.props.t("Excel Invoice")}</Link>
                    
                  </li> */}
                  <li>
                   
                    <Link to="/excelPurchaseCompany">{this.props.t("Excel Purchase")}</Link>
                  </li>
                  <li>
                   
                    <Link to="/ExcelLedgerWiseBill">{this.props.t("Excel Ledger Wise")}</Link>
                  </li>
                  {/* <li>
                   
                    <Link to="/ExcelGroup">{this.props.t("Excel Group")}</Link>
                  </li>
                  <li>
                   
                    <Link to="/ExcelLedger">{this.props.t("Excel Ledger")}</Link>
                  </li> */}
                </ul>
              </li>

              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-receipt" />
                  <span>{this.props.t("Tools")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/globaloptions">
                      {this.props.t("Global Options")}
                    </Link>
                  </li>
                  {/* <li>
                    <Link to="/DeleteTransactions">
                      {this.props.t("Delete Options")}
                    </Link>
                  </li> */}
                  {/* <li>
                    <Link to="/RestoreTransactions">
                      {this.props.t("Restore Options")}
                    </Link>
                  </li> */}
                  

                   {/* <li>
                    <Link to="ManageUser">{this.props.t("ManageUser")}</Link>
                  </li> */}
{ this.state.user && this.state.user.UserType && this.state.user.UserType === 'Admin' ? (
 <li>
 <Link to="UserMaster">{this.props.t("UserMaster")}</Link>
</li> 
) : null}
                 
                </ul>
              </li>
            </ul>
          </div>
        </SimpleBar>
      </React.Fragment>
    );
  }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
};

export default withRouter(withTranslation()(SidebarContent));
